# English language
# Ключи читает генератор канвы CRM: crm-vue tool/gen-site-dictionary.mjs — правишь здесь, перегенерируй там.
app:
  title: "VINPROP - Real Estate"
  home_title: "Vietnam Real Estate for Sale {'|'} Investment Property {'|'} VINPROP"

common:
  view_all: "View all"
  send: "Send"
  cancel: "Cancel"
  ok: "OK"
  back: "Back"
  retry: "Retry"
  next: "Next"
  scroll_prev: "Previous"
  scroll_next: "Next items"
  loading: "Loading..."
  error: "Error"
  success: "Success"
  back_to_home: "Back to Home"
  select: "Select"
  selected: "Selected"
  error_with_message: "Error: {message}"
  menu: "Menu"
  close: "Close"
  # DEV-2334: номер страницы к H1 и <title> на /page/N — как PageTitleSuffix в SSR
  # (ssr internal/domain/services/template_labels.go). Генератор ssr этот ключ пока не берёт.
  page_title_suffix: " — Page {page}"
header:
  # DEV-2334: H1 главной; SSR повторяет его генератором (ssr scripts/gen-site-texts).
  hero_text: "Vietnam real estate: new developments and resort property"

menu:
  projects_buy: "Buy Real Estate"
  residential_complexes: "Residential Projects"
  gated_communities: "Gated Communities"
  holiday_homes: "Resort Property"
  commercial_real_estate: "Commercial Real Estate"
  services: "Services"
  handbook: "Real Estate Handbook"
  research_analytics: "Research and Analytics"
  news_blog: "News"
  agents: "For Agents"
  articles: "Articles"
  articles_sub:
    buy_real_estate_vietnam: "Buy Real Estate in Vietnam"
    analytics: "Market Analytics"
    investment: "Investment"
  callback: "Callback"
  view_all: "View all"

breadcrumbs:
  home: "Home"

search:
  project_type: "Project Type"
  location: "Location"
  bedroom: "Number of Bedrooms"
  min_price: "Minimum Price USD"
  max_price: "Maximum Price USD"
  search_button: "Search"
  price: "Price"
  reset: "Reset"
  room_single: "room"
  room_few: "rooms"
  room_many: "rooms"
  project_types:
    residential_complex: "Residential Project"
    gated_community: "Gated Community"
    villa: "Villa"
    holiday_homes: "Resort Property"
    commercial_real_estate: "Commercial Real Estate"
  rooms:
    one: "1 bedroom"
    many: "{count} bedrooms"
    more: "5+ bedrooms"
  from_price: "from {price}"
  to_price: "to {price}"

# DEV-218: поиск ЖК по названию (лупа в шапке, поле в мобильном drawer)
rc_search:
  open: "Find a project by name"
  label: "Project name"
  placeholder: "Name, developer, city"
  clear: "Clear"
  close: "Close search"
  results: "Suggestions"
  nothing_found: "Nothing found for “{query}”"
  nothing_found_hint: "Check the spelling or browse the whole catalog"
  unavailable: "Search is temporarily unavailable"
  unavailable_hint: "Try again later or pick a project in the catalog"
  catalog_link: "View all projects"
  hint_choose: "select"
  hint_open: "open"
  hint_close: "close"

object_type:
  invalid: "Not specified"
  villa: "Villa"
  condotel: "Condotel"
  shophouse: "Shophouse"
  apartment: "Apartment"
  studio: "Studio"
  penthouse: "Penthouse"
  duplex: "Duplex"

amenities:
  invalid: "Not specified"
  bar: "Bar"
  restaurant: "Restaurant"
  spa: "Spa"
  yoga: "Yoga"
  convenience_store: "Convenience Store"
  shopping_mall: "Shopping Mall"
  school: "School"
  kindergarten: "Kindergarten"
  college: "College"
  swimming_pool: "Swimming Pool"
  kids_playground: "Kids Playground"
  gym: "Gym"
  community_room: "Community Room"
  jogging_path: "Jogging Path"
  bbq: "BBQ"
  green_area: "Green Area"
  tennis_court: "Tennis Court"
  kids_pool: "Kids Pool"
  parking: "Parking"
  cafe: "Cafe"

countries:
  af: "Afghanistan"
  al: "Albania"
  dz: "Algeria"
  ad: "Andorra"
  ao: "Angola"
  ag: "Antigua and Barbuda"
  ar: "Argentina"
  am: "Armenia"
  au: "Australia"
  at: "Austria"
  az: "Azerbaijan"
  bs: "Bahamas"
  bh: "Bahrain"
  bd: "Bangladesh"
  bb: "Barbados"
  by: "Belarus"
  be: "Belgium"
  bz: "Belize"
  bj: "Benin"
  bt: "Bhutan"
  bo: "Bolivia"
  ba: "Bosnia and Herzegovina"
  bw: "Botswana"
  br: "Brazil"
  bn: "Brunei"
  bg: "Bulgaria"
  bf: "Burkina Faso"
  bi: "Burundi"
  kh: "Cambodia"
  cm: "Cameroon"
  ca: "Canada"
  cv: "Cape Verde"
  cf: "Central African Republic"
  td: "Chad"
  cl: "Chile"
  cn: "China"
  co: "Colombia"
  km: "Comoros"
  cg: "Congo"
  cd: "DR Congo"
  cr: "Costa Rica"
  ci: "Ivory Coast"
  hr: "Croatia"
  cu: "Cuba"
  cy: "Cyprus"
  cz: "Czech Republic"
  dk: "Denmark"
  dj: "Djibouti"
  dm: "Dominica"
  do: "Dominican Republic"
  ec: "Ecuador"
  eg: "Egypt"
  sv: "El Salvador"
  gq: "Equatorial Guinea"
  er: "Eritrea"
  ee: "Estonia"
  sz: "Eswatini"
  et: "Ethiopia"
  fj: "Fiji"
  fi: "Finland"
  fr: "France"
  ga: "Gabon"
  gm: "Gambia"
  ge: "Georgia"
  de: "Germany"
  gh: "Ghana"
  gr: "Greece"
  gd: "Grenada"
  gt: "Guatemala"
  gn: "Guinea"
  gw: "Guinea-Bissau"
  gy: "Guyana"
  ht: "Haiti"
  hn: "Honduras"
  hk: "Hong Kong"
  hu: "Hungary"
  is: "Iceland"
  in: "India"
  id: "Indonesia"
  ir: "Iran"
  iq: "Iraq"
  ie: "Ireland"
  il: "Israel"
  it: "Italy"
  jm: "Jamaica"
  jp: "Japan"
  jo: "Jordan"
  kz: "Kazakhstan"
  ke: "Kenya"
  ki: "Kiribati"
  kp: "North Korea"
  kr: "South Korea"
  kw: "Kuwait"
  kg: "Kyrgyzstan"
  la: "Laos"
  lv: "Latvia"
  lb: "Lebanon"
  ls: "Lesotho"
  lr: "Liberia"
  ly: "Libya"
  li: "Liechtenstein"
  lt: "Lithuania"
  lu: "Luxembourg"
  mo: "Macau"
  mg: "Madagascar"
  mw: "Malawi"
  my: "Malaysia"
  mv: "Maldives"
  ml: "Mali"
  mt: "Malta"
  mh: "Marshall Islands"
  mr: "Mauritania"
  mu: "Mauritius"
  mx: "Mexico"
  fm: "Micronesia"
  md: "Moldova"
  mc: "Monaco"
  mn: "Mongolia"
  me: "Montenegro"
  ma: "Morocco"
  mz: "Mozambique"
  mm: "Myanmar"
  na: "Namibia"
  nr: "Nauru"
  np: "Nepal"
  nl: "Netherlands"
  nz: "New Zealand"
  ni: "Nicaragua"
  ne: "Niger"
  ng: "Nigeria"
  mk: "North Macedonia"
  no: "Norway"
  om: "Oman"
  pk: "Pakistan"
  pw: "Palau"
  ps: "Palestine"
  pa: "Panama"
  pg: "Papua New Guinea"
  py: "Paraguay"
  pe: "Peru"
  ph: "Philippines"
  pl: "Poland"
  pt: "Portugal"
  qa: "Qatar"
  ro: "Romania"
  ru: "Russia"
  rw: "Rwanda"
  kn: "Saint Kitts and Nevis"
  lc: "Saint Lucia"
  vc: "Saint Vincent and the Grenadines"
  ws: "Samoa"
  sm: "San Marino"
  st: "Sao Tome and Principe"
  sa: "Saudi Arabia"
  sn: "Senegal"
  rs: "Serbia"
  sc: "Seychelles"
  sl: "Sierra Leone"
  sg: "Singapore"
  sk: "Slovakia"
  si: "Slovenia"
  sb: "Solomon Islands"
  so: "Somalia"
  za: "South Africa"
  ss: "South Sudan"
  es: "Spain"
  lk: "Sri Lanka"
  sd: "Sudan"
  sr: "Suriname"
  se: "Sweden"
  ch: "Switzerland"
  sy: "Syria"
  tw: "Taiwan"
  tj: "Tajikistan"
  tz: "Tanzania"
  th: "Thailand"
  tl: "East Timor"
  tg: "Togo"
  to: "Tonga"
  tt: "Trinidad and Tobago"
  tn: "Tunisia"
  tr: "Turkey"
  tm: "Turkmenistan"
  tv: "Tuvalu"
  ug: "Uganda"
  ua: "Ukraine"
  ae: "UAE"
  gb: "United Kingdom"
  us: "United States"
  uy: "Uruguay"
  uz: "Uzbekistan"
  vu: "Vanuatu"
  va: "Vatican City"
  ve: "Venezuela"
  vn: "Vietnam"
  ye: "Yemen"
  zm: "Zambia"
  zw: "Zimbabwe"

featured_listings:
  title: "Featured Properties"
  urban_title: "Best urban real estate deals for {month} {year}"
  resort_title: "Best resort real estate deals for {month} {year}"
  empty: "No featured properties available"
  months:
    1: "January"
    2: "February"
    3: "March"
    4: "April"
    5: "May"
    6: "June"
    7: "July"
    8: "August"
    9: "September"
    10: "October"
    11: "November"
    12: "December"

guides:
  title: "Real Estate Handbook"
  coming_soon: "This guide is coming soon. Stay tuned for updates!"
  market_guide: "VN RE Market Guide"
  legal_guide: "Legal Guide"
  pm_guide: "Property Management Guide"
  buying_guide: "Buying Guide"

articles:
  all_title: "Articles"
  related_title: "Related articles"
  empty: "No articles"
  count: "{count} article | {count} articles"
  type:
    news: "News"
    services: "Services"
    handbook: "Handbook"
    research_analytics: "Market Analytics"
    buy_guide: "Buy Real Estate in Vietnam"
    investment: "Investment"
    default: "Article"
    all: "All Articles"
  filtered_by_tag: "Articles by tag"
  page: "Page"
  image_not_available: "Image not available"
  unknown_date: "Date unknown"
  not_found: "Article not found"
  go_back: "Back to articles"
  property_guide:
    title: "Property Management Guide in Vietnam"
    property_types: "Property Types"
    property_costs: "Property Costs"
    legal_aspects: "Legal Aspects"
    ownership_rules: "Ownership Rules"
    insurance_guidelines: "Insurance Guidelines"
    mortgages: "Mortgages in Vietnam"
    taxation_policies: "Taxation Policies"
  related_articles:
    title: "Related Articles"
    no_articles: "No related articles"
    error: "Error loading articles"
  slider:
    aria_label: "Featured properties"
    loading: "Loading featured properties"

form:
  title: "Fill out the form"
  subtitle: "Our specialists will contact you shortly"
  name: "Name"
  name_placeholder: "Enter your name"
  name_required: "Name is required"
  phone: "Phone"
  phone_placeholder: "+84 XXX XXX XXX"
  phone_required: "Phone is required"
  phone_invalid: "Invalid phone format"
  city_optional: "City (optional)"
  city_not_found: "Nothing found — leave the field empty"
  comment_optional: "Comment (optional)"
  city_interest: "City of interest (optional)"
  city_interest_placeholder: "Start typing a name"
  channel_legend: "How should we reach you?"
  channel_whatsapp: "WhatsApp"
  channel_telegram: "Telegram"
  channel_phone: "Call"
  contact_whatsapp: "Phone for WhatsApp"
  contact_phone: "Phone for a call"
  contact_telegram: "Telegram"
  telegram_placeholder: "{'@'}username or phone number"
  telegram_hint: "A username or a number — both work, we will figure it out"
  telegram_mode_nick: "Enter a username"
  telegram_mode_phone: "Enter a number"
  telegram_will_write: "We will message you on Telegram at {contact}"
  email: "Email"
  email_placeholder: "Enter your email"
  email_invalid: "Invalid email format"
  comment: "Comment"
  comment_placeholder: "Enter your comment"
  message: "Message"
  message_placeholder: "Tell us about your preferences..."
  submit: "Submit"
  submit_error: "Form submission error"
  success_title: "Thank you for your inquiry!"
  success_message: "We have received your request and will contact you shortly"
  submit_another: "Submit another request"
  privacy_note: "By clicking the button, you agree to the privacy policy and personal data processing"

sidebar_form:
  agent_name_placeholder: "Alexander Melnikov"
  agent_role: "Sales Manager"
  headline: "We'll find 3 best options for your budget"
  description: "with profitability forecast and payback period"
  submit: "Get a personal selection"

validation:
  required_name: "Name is required"
  required_phone: "Phone is required"
  invalid_phone: "Please enter a valid phone number"
  required_email: "Email is required"
  invalid_email: "Please enter a valid email"
  invalid_telegram: "A username needs at least 4 characters — check it or enter a number"
  min_length: "At least {min} characters"

error:
  network: "Network error: {message}"
  server: "Server error: {message}"
  form_submit: "Failed to submit the form. Please try again later."
  general: "An error occurred"
  page_not_found: "Page not found"
  page_not_found_description: "Sorry, the page you are looking for does not exist. It may have been removed or moved."

residential_complex:
  all_title: "Real Estate"
  reset_filters: "Reset filters"
  no_complexes: "No residential complexes"
  more_details: "More details"
  all_loaded: "All complexes loaded"
  not_found: "Residential complex not found"

complex_card:
  price_from: "from {price}"
  price_on_request: "Price on request"
  details: "Details"
  handover_date_not_specified: "Handover date not specified"
  handover_completed: "Completed"
  # DEV-2343: один формат срока сдачи на всех языках
  handover_quarter: "Q{quarter} {year}"
  from: "from"
  to: "to"
  sqm: "m²"
  area: "Area"
  price_range: "Price range"
  request_contacts: "Request contacts"
  apartments_available: "{count} apartments available"
  sold_out: "SOLD OUT"
  # DEV-2299: тот же текст в crm-vue (превью) и ssr
  sales_start: "SALES START {date}"
  studio: "Studio"
  delivery_in: "Delivery in"

complex_features:
  invalid: "Not specified"
  favorites: "Favorites"
  docs_checked: "Docs checked"
  video_available: "Video available"
  handovered: "Handovered"
  pink_book_available: "Pink book available"
  available_for_foreigners: "Available for foreigners"

filters:
  title: "Filters"
  project_rank: "Project Rank"
  amenities_title: "Amenities"
  features_title: "Features"
  rank:
    invalid: "Not specified"
    affordable: "Affordable"
    mid_end: "Mid-End"
    high_end: "High-End"
    luxury: "Luxury"

complex_details:
  characteristics:
    due_date: "Due date"
    class: "Complex class"
    altitude: "Altitude"
    room_type: "Room type"
    transport: "Transport accessibility"
    info_not_available: "Information not available"
  features:
    reputable_developer: "Reputable Developer"
    installment_plan: "Installment Plan"
    full_legal_ground: "Full Legal Ground"
    high_appreciation_potential: "High Appreciation Potential"
  class_type:
    high_end: "High End"
    mid_range: "Mid Range"
    economy: "Economy"
    luxury: "Luxury"
    invalid: "Not specified"
  room_type:
    apartment: "Apartment"
    penthouse: "Penthouse"
    duplex: "Duplex"
    studio: "Studio"
    invalid: "Not specified"
  developer_label: "Developer"
  handover_date_label: "Handover Date"
  project_class_label: "Project Class"
  complex_by_developer: "Residential complex by developer {name}"
  infrastructure: "Complex infrastructure"
  construction_progress: "Construction progress"
  construction_progress_description: "Photos from the construction site of the residential complex"
  construction_progress_date: "Photos as of {date}"
  amenity_categories:
    establishment: "Establishments"
    for_children: "For children"
    sport: "Sports"
    common_area: "Common Areas"
  amenities:
    bar: "Bar"
    restaurant: "Restaurant"
    spa: "Spa"
    yoga: "Yoga"
    convenience_store: "Convenience Store"
    shopping_mall: "Shopping Mall"
    school: "School"
    kindergarten: "Kindergarten"
    college: "College"
    swimming_pool: "Swimming Pool"
    kids_playground: "Kids Playground"
    gym: "Gym"
    community_room: "Community Room"
    jogging_path: "Jogging Path"
    bbq: "BBQ"
    green_area: "Green Area"
    tennis_court: "Tennis Court"
    kids_pool: "Kids Pool"
    parking: "Parking"
    cafe: "Cafe"
  documents:
    construction_permit: "Construction Permit"
    land_use_right_certificate: "Land Use Right Certificate"
    bank_letter_of_guarantee: "Bank Letter of Guarantee"
    sale_permit: "Sale Permit"
    sale_permit_for_foreigners: "Sale Permit for Foreigners"
  foreigners_heading: "Can a foreigner buy property in {name}?"
  foreigners_yes: "Yes, {name} is sold to foreign buyers."
  foreigners_permit: "The developer holds a permit to sell to foreigners — the document was verified by VINPROP lawyers."
  foreigners_pink_book: "The project issues the pink book, the Vietnamese certificate of ownership."
  foreigners_law: "Under Vietnamese law foreigners may own up to 30% of the apartments in one building; ownership is granted for 50 years and can be extended."
  master_plan: "Master plan"
  about_project: "About project"
  location: "Location"
  finishing_options: "Finishing options"
  finishing_options_from: "Finishing options from {name}"
  about_developer: "About developer"
  documents_checking: "Documents checking"
  other_complexes: "Other complexes by developer"
  open_map: "Open map"
  more_about_finishing: "More about finishing options"
  go_to_developer_page: "Go to developer page"
  finishing_description: "Various finishing options are available for apartments"
  finishing_note: "Images are for reference only and may differ from actual finishing"
  developer_contacts: "Developer contacts"
  image_not_available: "Image not available"
  plan_not_available: "Plan not available"
  get_consultation: "Get consultation"
  price_range: "{min} - {max}"
  offers_available: "{count} offer available | {count} offers available"
  contact_us: "Contact us"
  contact_description: "Fill out the form below and we will contact you shortly"
  available_apartments_in: "Available apartments in {name}"
  apartments_available: "Available apartments"
  special_offers: "Special offers"
  check_price_availability: "Check current prices and availability with the manager"
  bedrooms_count: "{count} bedrooms"
  bedrooms: "{count} bedrooms"
  studio: "Studio"
  rooms_unspecified: "Number of rooms not specified"
  units_available: "{count} available"
  buy_now: "Buy now"
  more_detailed: "More detailed"
  images:
    PROPERTY_IMAGE_TYPE_LAYOUT: "Floor plan"
    PROPERTY_IMAGE_TYPE_FINISHING: "Finishing options"
  object_type: "Object type"
  available_units: "Available"
  established: "Established"
  total_projects: "Total projects"
  completed_projects: "Completed projects"
  years_experience: "Years of experience"
  visit_website: "Visit website"
  contact_form_intro: "Interested in {name}? Leave a request and our manager will contact you"
  benefit_consultation: "Free specialist consultation"
  benefit_price: "Current prices and special offers"
  benefit_viewing: "Property viewing arrangement"
  benefit_documents: "Assistance with document verification"
  full_address: "Full address"
  district: "District"
  city: "City"
  loading_map: "Loading map..."
  map_error: "Map loading error"
  map_placeholder: "Location map"
  open_in_google_maps: "Open in Google Maps"
  nearby_places: "Nearby places"
  meters: "m"
  photo_date: "Photo on {date}"
  total_photos: "Total photos: {count}"
  last_update: "Last update: {date}"
  documents_verified: "Documents verified"
  documents_description: "All project documents have been legally verified by our specialists"
  document_verified: "Verified"
  document_pending: "Pending"
  documents_note: "Document information is updated regularly. Contact the manager for current data."
  other_complexes_by: "Other complexes by {name}"
  view_details: "View details"
  no_other_complexes: "No other complexes from this developer yet"
  starting_price: "Starting price"

footer:
  contacts: "Contacts:"
  company_section: "Company"
  legal_section: "Legal"
  about: "About Us"
  about_vinprop_title: "About VINPROP"
  about_snippet: "VINPROP is an international proptech company specializing in Vietnam's real estate market. We combine technological solutions, analytics, and consulting for foreign and local investors. We offer the purchase of apartments, villas, and commercial real estate in Ho Chi Minh City, Hanoi, Da Nang, and other cities in Vietnam."
  vn_company_name: "VINPROP REALTY VIETNAM LIMITED LIABILITY COMPANY"
  enterprise_code: "Enterprise code (Tax ID)"
  projects_section: "Projects / buy real estate"
  residential_complexes: "Residential Projects"
  gated_communities: "Gated communities"
  holiday_homes: "Resort property"
  commercial_real_estate: "Commercial real estate"
  services_section: "Services"
  advisory_services: "Advisory services"
  legal_consultation: "Legal consultation"
  property_management: "Property management"
  fit_out: "Fit-out"
  partners: "For partners"
  legal_disclaimer: "Legal Disclaimer"
  terms_of_use: "Terms of Use"
  careers: "Careers"
  privacy_policy: "Privacy Policy"
  cookie_policy: "Cookie Policy"
  handbook_section: "Real Estate Handbook"
  buying_guide: "Buying guide"
  legal_guide: "Legal guide"
  pm_guide: "PM guide"
  market_guide: "VN RE market guide"
  developer_profiles: "Developer's profiles"
  research_section: "Research and Analytics"
  news_blog: "News / blog"

cookie_consent:
  title: "Cookie Usage"
  description: "We use cookies to improve your experience on our website, analyze traffic, and personalize content. You can customize your preferences or accept all cookies."
  customize: "Customize"
  accept_all: "Accept All"
  reject_all: "Necessary Only"
  save_preferences: "Save Preferences"
  necessary: "Necessary Cookies"
  necessary_desc: "These cookies provide basic website functionality and cannot be disabled."
  analytics: "Analytics Cookies"
  analytics_desc: "Help us understand how visitors interact with our website by collecting anonymous statistics."
  marketing: "Marketing Cookies"
  marketing_desc: "Used to display relevant advertising and track the effectiveness of advertising campaigns."
  preferences: "Personalization Cookies"
  preferences_desc: "Save your preferences (language, theme, etc.) to improve your user experience."
city_autocomplete:
  placeholder: "Start typing a city…"
  min_chars: "Enter at least 2 characters"
  loading: "Loading…"
  not_found: "Nothing found"
  load_error: "Failed to load suggestions"
  retry: "Retry"
  clear: "Clear"
  manual_entry: "Enter manually: “{query}”"
  manual_suffix: "(entered manually)"
  back_to_search: "Back to directory search"

# DEV-1722: страница застройщика /developers/{slug}
# DEV-1719: two city pages with different intents — listing and guide.
city:
  # DEV-2334: {in_city} — city_in.<slug> или in_city ниже. SSR повторяет эти
  # строки генератором (ssr scripts/gen-site-texts) — правка требует перегенерации в ssr.
  catalog_title: "Apartments for sale {in_city}: new developments"
  catalog_seo_title: "Buy an apartment {in_city}: prices and new builds {'|'} VINPROP"
  # Фолбэк для города, которого нет в city_in
  in_city: "in {city}"
  guide_title: "{city}: A Property Buyer's Guide"
  # DEV-1097: <title> вкладки. Не равен H1 — у SSR для него свой шаблон
  # (ssr/internal/domain/services/city_page.go, cityGuideFormats.Title),
  # и по одному URL заголовок обязан быть один. Правка seo_title города
  # из админки главнее шаблона — как и в SSR.
  guide_seo_title: "{city} City Guide — Districts, Prices, Buying Property {'|'} VINPROP"
  guide_link: "About {city} →"
  catalog_link: "All projects in the city →"
  guide_crumb: "City guide"
  projects_title: "Projects in {city}"
  catalog_link_count: "All {count} projects in the city →"

# DEV-1758: cities hub /locations. Wording matches the SSR hub
# (ssr/internal/domain/services/city_page.go): one address, one page.
locations_hub:
  title: "Cities of Vietnam"
  seo_title: "Cities of Vietnam — property buyer's guides {'|'} VINPROP"
  intro: "Cities of Vietnam with a VINPROP guide: districts, infrastructure, prices and the rules for foreign buyers. Each city comes with the projects on sale there."
  empty: "City guides are being prepared."
  all: "All cities"
  crumb: "Cities"
  projects_count: "{count} project | {count} projects"

# DEV-1762: developers hub /developers
developers_hub:
  title: "Vietnam property developers"
  intro: "Companies whose projects are on sale at VINPROP. Each has a profile and the full list of residential complexes with prices and handover dates."
  empty: "The developer directory is currently empty."
  all: "All developers"

developer:
  projects: "Projects by this developer"
  no_projects: "This developer has no projects on sale right now."
  not_found: "Developer not found"

# DEV-1808: home hero — the H1 lives here, not in the header
home:
  hero:
    eyebrow: "VINPROP · Vietnam real estate"
    subtitle: "Apartment complexes, villas and resort projects across Vietnam — current prices and support in your language"
    all_cities: "All cities"
  stats:
    projects: "project in the catalogue | projects in the catalogue"
    cities: "city | cities"
  # DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
  # правка здесь требует перегенерации в ssr.
  intro:
    title: "How to buy property in Vietnam with VINPROP"
    p1: "Vietnam real estate open to foreign buyers is mostly apartments in new residential complexes and resort projects on the coast. Our catalog covers new developments in Ho Chi Minh City, Hanoi, Hai Phong, Da Nang, Nha Trang, Vung Tau, Phu Quoc and other cities. The large cities suit buyers who plan to live there or rent out long term; the coast suits holiday homes and short-term rentals to tourists. You can buy during construction or in a finished building, and each project has its own payment terms and completion date."
    p2: "Can foreigners buy property in Vietnam? Yes: mainly commercial housing, plus some resort projects. For an apartment in a residential complex, you sign a sale and purchase agreement (SPA) with the developer and, once the building is complete, receive the ownership certificate known as the Pink Book. A foreign owner gets it for 50 years, extendable once for another 50. Foreigners may own no more than 30 percent of the apartments in one apartment building, so the remaining quota is checked before booking. On the resale market a foreigner can buy only from another foreigner but can sell to anyone. Social housing is closed to foreigners, and resort condotels are held under a long-term lease, not a Pink Book."
    p3: "The purchase follows a clear sequence. You choose a unit, book it and pay a deposit. This can be done from abroad through an agency with a Vietnamese bank account, since a developer can refund a deposit only to an account inside Vietnam. The SPA for residential property must be signed in person while you are legally in Vietnam. On the same trip you open a personal account at a local bank. All payments to the developer are in Vietnamese dong: you transfer your own money to your Vietnamese account and pay from there, in full or through an interest-free installment plan during construction. After handover the Pink Book is issued, with a registration fee of 0.5 percent."
    p4: "VINPROP makes sure you understand what happens at every step and why. We shortlist projects that fit your goal, whether you plan to live there, rent the property out or hold it long term, and check the developer and the paperwork: building and sales permits, approval to sell to foreigners, the remaining quota and the draft contract. The SPA for foreign buyers is bilingual, Vietnamese and English, and we go through it with you. Then we support the deal from booking to Pink Book: the deposit, your trip to sign, the bank account and the transfers in dong. Russian-speaking support is available throughout."
    p5: "Why Vietnam? The economy is growing steadily, foreign investment keeps flowing in, cities are expanding and building infrastructure, and prices remain relatively low compared with other Asian markets. The system also works in the owner's favor: there is no annual property tax on housing, tax rates are the same for foreigners and Vietnamese citizens, and ownership is extended through a state procedure, not a negotiation with a landowner. Still, this market rewards caution. Developers differ widely in reliability, so decide after a proper check, not on advertised returns."
  faq:
    title: "Buying property in Vietnam: frequently asked questions"
    q1: "Can foreigners buy property in Vietnam?"
    a1: "Yes. A foreign national can buy an apartment in a commercial housing project and receive a Pink Book, the official ownership certificate. A quota applies: foreigners may own no more than 30 percent of the apartments in one apartment building. You can buy from the developer or from another foreign owner. Social housing is not available to foreign buyers."
    q2: "How long can a foreigner own an apartment, and can ownership be extended?"
    a2: "A Pink Book issued to a foreigner is valid for 50 years, and the law gives the owner the right to a one-time renewal for another 50 years. Renewal costs 0.5 percent of the original contract price. If you sell to a Vietnamese citizen, the new owner holds the apartment with no time limit. Condotels work differently: they are held under a long-term lease for the remaining term of the developer's land lease, usually up to 50 years."
    q3: "What taxes apply when you buy, own and sell property in Vietnam?"
    a3: "Buying a new apartment from a developer involves 10 percent VAT, which is usually already included in the price, and a 0.5 percent registration fee when the Pink Book is issued. Vietnam has no annual property tax on homes. When you sell, a 2 percent tax is charged on the gross price stated in the contract. The rates are the same for foreigners and Vietnamese citizens."
    q4: "Do I need to travel to Vietnam in person, and how do I pay?"
    a4: "For an apartment with a Pink Book, yes: the SPA must be signed in person in Vietnam, not by power of attorney. The reservation deposit can be paid remotely through an agency. All payments are made in Vietnamese dong: you open a personal account with a local bank (this requires a three-month visa), transfer your own funds and pay the developer from it. Condotels can be bought remotely."
    q5: "Does VINPROP help with due diligence and the purchase itself?"
    a5: "Yes. We check the developer and the project documents, including the construction permit, permission to sell to foreigners, the remaining foreign quota and the draft SPA. We then support the deal from reservation to Pink Book, coordinating paperwork, notarization and government offices, and helping you set up payments. Russian-speaking support is available at every step."

# DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
# правка здесь требует перегенерации в ssr.
# H1, <title> и вводный текст каталогов /properties[/:type]; ключ раздела — слаг роута через «_».
catalog:
  h1:
    all: "Apartments and new developments in Vietnam"
    residential_complex: "Residential complexes in Vietnam: new-build apartments"
    holiday_homes: "Resort property in Vietnam: holiday apartments and condotels"
    gated_community: "Gated communities in Vietnam"
    commercial: "Commercial property in Vietnam"
  title:
    all: "Apartments for sale in Vietnam: new builds and prices {'|'} VINPROP"
    residential_complex: "Residential complex apartments for sale in Vietnam {'|'} VINPROP"
    holiday_homes: "Holiday homes and condotels for sale in Vietnam {'|'} VINPROP"
    gated_community: "Villas and townhouses in Vietnam's gated communities {'|'} VINPROP"
    commercial: "Commercial premises in Vietnam: project catalog {'|'} VINPROP"
  intro:
    all:
      p1: "This page brings together every project in our catalog: apartments in residential complexes in the major cities and resort property on the coast. Narrow the list with the filters for city, price and completion date. A finished building suits you if you need the apartment now; a project under construction suits you if you can wait and pay on the developer's schedule. Each project page shows floor plans and the completion timeline."
      p2: "Before comparing prices, decide which format you need. An apartment in a residential complex is owned under a Pink Book, while resort apartments are bought under a long-term lease, and the rules differ. If you are unsure, get in touch: VINPROP will shortlist suitable options, check the developer and the documents, and support the deal until you have the keys and your documents."
    residential_complex:
      p1: "This section lists residential complexes, that is, commercial housing a foreigner can own. Once the building is complete, the buyer receives a Pink Book for 50 years with the right to extend for another 50, and a sale to a Vietnamese citizen removes the time limit for the new owner. Residential projects are also subject to mandatory bank guarantees for construction, which do not apply to resort projects."
      p2: "Use the filters to choose the city, budget and completion date. Check the remaining foreign quota early: foreigners may own no more than 30 percent of the apartments in one apartment building. For buildings under construction, developers usually offer interest-free installments until handover. VINPROP will verify the project permits and the quota and support you from booking to Pink Book."
    holiday_homes:
      p1: "Resort property means apartments and condotels in tourist areas such as Phu Quoc, Nha Trang, Da Nang and other coastal cities. Legally this is a different format from an apartment in a residential complex: instead of a Pink Book, the buyer gets the right to use the unit under a long-term lease for the remaining term of the developer's land lease, usually up to 50 years. On the plus side, the contract can be signed from abroad without a trip to Vietnam."
      p2: "Demand here rests on tourism, so rental income and resale prospects follow the flow of guests and the quality of the management company; many projects work with hotel operators. Keep in mind that resort projects are not covered by mandatory bank guarantees for construction, and the developer may ask for full payment before completion. Filter by city, price and completion date, and let VINPROP check the legal status of the project and the developer."

# DEV-2334: SSR повторяет эти строки генератором (ssr scripts/gen-site-texts);
# правка здесь требует перегенерации в ssr.
# «в Нячанге»: город с предлогом для city.catalog_*; ключ — слаг города через «_».
city_in:
  ho_chi_minh: "in Ho Chi Minh City"
  hanoi: "in Hanoi"
  da_nang: "in Da Nang"
  nha_trang: "in Nha Trang"
  vung_tau: "in Vung Tau"
  hai_phong: "in Hai Phong"
  hung_yen: "in Hung Yen"
  phu_quoc: "in Phu Quoc"
  hue: "in Hue"
  quang_ninh: "in Quang Ninh Province"
  lao_cai: "in Lao Cai"
  phan_thiet: "in Phan Thiet"
  quy_nhon: "in Quy Nhon"
  tuyen_quang: "in Tuyen Quang"
